import { connect } from "react-redux";
import RealtimeDashboard from "../../Components/RealtimeDashboard/RealtimeDashboard";

const mapStateToProps = (state) => ({
  queues: state.reducer.QUEUES,
  agents: state.reducer.AGENTS,
  scopes: state.reducer.SCOPES,
  // Le tableau de bord lisait le tenant du COMPTE CONNECTÉ, jamais celui sélectionné dans
  // l'en-tête : un revendeur regardait donc le temps réel de sa propre entreprise en croyant
  // voir celui de son client.
  ACTIVE_TENANT: state.reducer.ACTIVE_TENANT,
});

const mapDispatchToProps = (dispatch) => ({
  // Add dispatch actions here if needed
});

export default connect(mapStateToProps, mapDispatchToProps)(RealtimeDashboard);
